import React, { useState } from "react";

import EditIcon from '@mui/icons-material/Edit';
import { Delete } from "@mui/icons-material";

import { TableRow, TableCell, IconButton, Box, Button, DialogActions, DialogContentText, Dialog, DialogTitle, DialogContent } from "@mui/material";
import DialogModifyMovimiento from "./DialogModifyMovimiento";

const formatNumber = (num) => {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

const MovimientoEmpleadoRowTable = ({data, handleDelete, areUserAdmin, idMov, currentCaja, onMovementSuccess}) => {
  const [openAlertDelete, setOpenAlertDelete] = useState(false);
  const [openModifyDialog, setOpenModifyDialog] = useState(false);
  
  const handleOpenModifyDialog = () => { setOpenModifyDialog(true) }
  const handleCloseModifyDialog = () => { setOpenModifyDialog(false) }

  return (
    <React.Fragment>
      { areUserAdmin && <Dialog
        open={openAlertDelete}
        keepMounted
        onClose={() => {setOpenAlertDelete(false)}}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Espera un Segundo!"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Estás apunto de eliminar este Movimiento del Registro de Movimientos de este parqueadero
            ¿Estás seguro de que quieras hacer esto?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {setOpenAlertDelete(false)}} color='error' variant="outlined">No</Button>
          <Button onClick={() => {setOpenAlertDelete(false); handleDelete(data.id); }} color='primary' variant="contained">¡Sí!</Button>
        </DialogActions>
      </Dialog>}

      <TableRow>
        <TableCell component="th" scope="row" sx={{ borderLeft: '2px solid #ddd', borderBottom: '2px solid #ddd' }}> {idMov} </TableCell>
        <TableCell align="left" sx={{ borderLeft: '2px solid #ddd', borderBottom: '2px solid #ddd' }}> {data.tipo} </TableCell>
        <TableCell align="left" sx={{ borderLeft: '2px solid #ddd', borderBottom: '2px solid #ddd'}}> {formatNumber(data.monto)} </TableCell>
        <TableCell align="left" sx={{ borderLeft: '2px solid #ddd', borderBottom: '2px solid #ddd'}}> {data.fecha} </TableCell>
        <TableCell align="left" sx={{ borderLeft: '2px solid #ddd', borderBottom: '2px solid #ddd', borderRight: areUserAdmin ? null : '2px solid #ddd'}}> {data.observacion === '' ? 'Nada' : data.observacion} </TableCell>
        {areUserAdmin && <TableCell sx={{ borderLeft: '2px solid #ddd', borderRight: '2px solid #ddd', borderBottom: '2px solid #ddd'}}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <IconButton
                size="large"
                onClick={() => {handleOpenModifyDialog()}}
                sx={{ color: '#33eaff', padding: 0, border: '2px solid #33eaff' }}
              >
                <EditIcon sx={{ fontSize: '33px' }}/>
              </IconButton>
              <IconButton
                size="large"
                onClick={() => { setOpenAlertDelete(true) }} // Se ejecuta la eliminación
                sx={{ color: '#d32f2f', padding: 0, border: '2px solid #d32f2f' }}
              >
                <Delete sx={{ fontSize: '33px' }}/>
              </IconButton>
          </Box>
        </TableCell>}
      </TableRow>

      <DialogModifyMovimiento dialogOpen={openModifyDialog} handleDialogClose={handleCloseModifyDialog} data={data} currentCaja={currentCaja} onMovementSuccess={onMovementSuccess}/>

    </React.Fragment>
  );
}

export default MovimientoEmpleadoRowTable;
